module.exports = __webpack_public_path__ + "static/media/tracklastmile-logo.2c37033a.svg";